<template>
  <div>
    <div class="card-header d-flex justify-content-between">
      <h6 class="lh-5 mg-b-0">Захиалгын түүх</h6>
      <b-pagination
        v-if="allCount > 0"
        class="mg-r-20"
        size="sm"
        align="center"
        v-model="pager.page"
        :total-rows="allCount"
        :per-page="pager.size"
        @change="pageChanged"
        style="margin-bottom: 0"
      ></b-pagination>
    </div>
    <div class="card-body pd-x-0 pd-y-10">
      <div
        class="
                ht-100
                d-flex
                align-items-center
                justify-content-between
                pd-x-100
              "
      >
        <div class="media">
          <div
            class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-primary
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
          >
            <feather type="menu"></feather>
          </div>
          <div class="media-body">
            <h6
              class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
            >
              Нийт захиалга
            </h6>
            <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
              {{ statObj.data.order.allCount }}
            </h4>
          </div>
        </div>
        <div class="media">
          <div
            class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-success
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
          >
            <feather type="menu"></feather>
          </div>
          <div class="media-body">
            <h6
              class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
            >
              Баталгаажсан захиалга
            </h6>
            <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
              {{ statObj.data.order.acceptedCount }}
            </h4>
          </div>
        </div>
        <div class="media">
          <div
            class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-danger
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
          >
            <feather type="menu"></feather>
          </div>
          <div class="media-body">
            <h6
              class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
            >
              Буцаан өгсөн
            </h6>
            <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
              {{ statObj.data.order.returnedCount }}
            </h4>
          </div>
        </div>
        <div class="media">
          <div
            class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-warning
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
          >
            <feather type="menu"></feather>
          </div>
          <div class="media-body">
            <h6
              class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
            >
              Надад байгаа
            </h6>
            <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
              {{ statObj.data.order.inProgressCount }}
            </h4>
          </div>
        </div>
      </div>
      <vue-custom-scrollbar :style="`height: ${getScrollHeight(295)}`">
        <lib-orders :tasks="tasks" @on-cancel-order="cancelOrderConfirm" />
      </vue-custom-scrollbar>
    </div>
    <b-overlay :show="overlayObj.busy" no-wrap>
      <template #overlay>
        <div
          v-if="overlayObj.processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="overlayObj.busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="overlayPost()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    libOrders: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/orders.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      overlayObj: {
        processing: false,
        busy: false,
        processingId: 0,
      },
      statObj: {
        data: {},
        rdy: false,
      },
      tasks: [],
      nowDate: "",
      allCount: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    pageChanged(e) {
      this.pager.page = e;
      this.init();
    },
    init() {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 504,
          model: {
            secondUserId: this.$store.state.user.userId,
          },
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.nowDate = res.data.nowDate;
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
    getScrollHeight(mv) {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }

      if (mv != undefined) {
        mh = mv;
      }

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    cancelOrderConfirm(e) {
      this.overlayObj.processingId = e.id;
      this.overlayObj.busy = true;
    },
    initStat() {
      request({
        api: { method: "GET", url: "library/MyDashboard" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.statObj.data = res.data.stat;
          this.statObj.rdy = true;
        }
      });
    },
    overlayPost() {
      this.overlayObj.processing = true;
      let url = "library/DeclineOrder";
        if (this.$route.params.m == 4) {
          url = "library/DeclineOrder";
        }
      request({
        data: {
          id: this.overlayObj.processingId,
        },
        api: { url: url, method: "POST" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.overlayObj.busy = false;
          this.overlayObj.processing = false;
          this.tasks = [];
          this.init();
          this.initStat();
        }
      });
    },
  },
};
</script>
